import {Receipt} from 'lucide-react';
import {Alert, CircularProgress} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {PortalShell} from '../../shared/ui';
import {FILTROS_DA_FATURA, formatCompetencia, formatDateBR, formatMoneyBR, situacaoDaFatura} from './financeiroUtils';
import {useFinanceiro} from './useFinanceiro';

export default function FinanceiroPage() {
    const navigate = useNavigate();
    const data = useFinanceiro();
    const {pagination} = data;

    return (
        <PortalShell>
            <div className="bf-page">
                <div>
                    <h1 className="bf-page__title">Financeiro</h1>
                    <p className="bf-page__subtitle">Veja as faturas das suas empresas e pague por boleto ou Pix.</p>
                </div>

                {data.error ? <Alert severity="warning">{data.error}</Alert> : null}

                <div className="bf-card"><div className="bf-card__body">
                    <div className="bf-filter-row" style={{marginBottom: 24}}>
                        {FILTROS_DA_FATURA.map((filtro) => (
                            <button
                                key={filtro.value || 'todas'}
                                className={`bf-button ${data.status === filtro.value ? 'bf-button--primary' : 'bf-button--secondary'} bf-button--sm`}
                                aria-pressed={data.status === filtro.value}
                                onClick={() => data.setStatus(filtro.value)}
                            >
                                {filtro.label}
                            </button>
                        ))}
                    </div>

                    {data.loading ? (
                        <div className="bf-empty"><CircularProgress /></div>
                    ) : (
                        <>
                            <div className="bf-table-wrap">
                                <table className="bf-table">
                                    <thead>
                                        <tr>
                                            <th>Fatura</th>
                                            <th>Empresa</th>
                                            <th>Referência</th>
                                            <th>Vencimento</th>
                                            <th>Valor</th>
                                            <th>Situação</th>
                                            <th style={{textAlign: 'right'}}>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.faturas.map((fatura) => {
                                            const situacao = situacaoDaFatura(fatura.status);
                                            return (
                                                <tr key={fatura.id}>
                                                    <td style={{fontWeight: 500, whiteSpace: 'nowrap'}}><span className="bf-code">{fatura.numero || '-'}</span></td>
                                                    <td>{fatura.empresa}</td>
                                                    <td className="bf-muted">{fatura.referencia || formatCompetencia(fatura.competencia)}</td>
                                                    <td className="bf-muted">{formatDateBR(fatura.vencimento)}</td>
                                                    <td style={{fontWeight: 600}}>{formatMoneyBR(fatura.valorTotal)}</td>
                                                    <td><span className={situacao.className}>{situacao.label}</span></td>
                                                    <td>
                                                        <div className="bf-row" style={{justifyContent: 'flex-end'}}>
                                                            <button className="bf-button bf-button--ghost bf-button--sm" onClick={() => navigate(`/financeiro/${fatura.id}`)}>
                                                                <Receipt size={16} /><span>Ver fatura</span>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {data.faturas.length === 0 && !data.error ? <div className="bf-empty">Nenhuma fatura encontrada.</div> : null}

                            {pagination.totalPages > 1 ? (
                                <div className="bf-row-between" style={{marginTop: 16}}>
                                    <span className="bf-muted" style={{fontSize: 14}}>Página {data.page} de {pagination.totalPages}</span>
                                    <div className="bf-row" style={{gap: 8}}>
                                        <button className="bf-button bf-button--secondary bf-button--sm" disabled={!pagination.hasPrevious} onClick={() => data.setPage(data.page - 1)}>Anterior</button>
                                        <button className="bf-button bf-button--secondary bf-button--sm" disabled={!pagination.hasNext} onClick={() => data.setPage(data.page + 1)}>Próxima</button>
                                    </div>
                                </div>
                            ) : null}
                        </>
                    )}
                </div></div>
            </div>
        </PortalShell>
    );
}
